import { useNewEditTemplateCollectionContext } from "@pages/collectionAdministration/pages/NewEditTemplateCollection/context/NewEditTemplateCollectionContext"

export const useCollectionEditTableOptions = () => {

    const { setCleanTable, setHasUnsavedChanges } = useNewEditTemplateCollectionContext()

    const handleDownloadTemplate = async () => {
        console.log('DESCARGAR PLANTILLA')
    }

    const handleCleanTable = async () => {
        setHasUnsavedChanges(true)
        setCleanTable(true)
    }

    return {
        handleDownloadTemplate,
        handleCleanTable
    }
}